import { Col, Divider, Progress, Row, Typography } from "antd";
import React, { useEffect, useState } from "react";
import "./index.css";
import { retriveToken, fetchAuth } from "../../../../services/AuthServices";
import { useDispatch, useSelector } from "react-redux";
// import { login } from "../../../../actions/loginAction";
import { login } from "../../../../reducers/loggedinuser";
import Trophy from "../../../../assets/trophy.svg";
import InfoIcon from "../../../../assets/infoIcon.svg";
import { useNavigate } from "react-router-dom";

// import { Line } from "react-chartjs-2";

// import { faker } from "@faker-js/faker";
import { useRef } from "react";
import {
  Bar,
  BarChart,
  CartesianAxis,
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { getGrade, getGradeSecondary } from "../../utils";
import { useWindowDimensions } from "../../examPortal/testBoard";

function truncateString(str, maxLength) {
  if (str?.length > maxLength) {
    return str?.slice(0, maxLength) + "...";
  }
  return str;
}

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div style={{ backgroundColor: "white", padding: 10 }}>
        {payload.map((entry, index) => (
          <div key={index} style={{ display: "flex", color: "black" }}>
            <Typography.Text>
              {truncateString(entry.payload.label, 20)}
            </Typography.Text>
            <Typography.Text>: {entry.payload.value}%</Typography.Text>
          </div>
        ))}
      </div>
    );
  }
  return null;
};

const progressStyleCol = {
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
  gap: "8px",
};

const today = new Date();
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const last5Months = [];
for (let i = 4; i >= 0; i--) {
  const currentMonth = (today.getMonth() - i + 12) % 12;
  last5Months.push({ month: months[currentMonth] });
}

const SubjectDetails = ({ title, id }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth);
  // console.log(user.user);

  const { width } = useWindowDimensions();
  const [info, setInfo] = useState(false);

  const startingTime = new Date(user?.user?.countDownStartingTime);
  const endingTime = new Date(user?.user?.countDownTimer);
  const timeDifference = endingTime - startingTime;
  const currentTime = new Date();
  const timeElapsed = currentTime - startingTime;
  const daysElapsed = Math.ceil(timeElapsed / (1000 * 60 * 60 * 24));
  const totalDays = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
  const percentageDayLeft = (daysElapsed / totalDays) * 100;

  useEffect(() => {
    const t = retriveToken();
    // console.log(t);

    if (t && t !== "undefined" && title) {
      fetchAuth(t, title).then((response) => {
        // console.log(response.data.user);
        dispatch(login(response.data.user));
      });
    } else {
      navigate("/");
    }
  }, [title]);

  return (
    <div className="container">
      <div className="stack">
        <Typography.Title
          level={4}
          style={{
            color: "#f1f1f1",
            fontWeight: 400,
            fontSize: 26,
            letterSpacing: 2,
          }}
        >
          Welcome back, {user?.user?.name}
        </Typography.Title>
      </div>
      <div className="stateContainer">
        <div style={{ width: "30%", margin: "auto" }}>
          <Divider />
        </div>
        <Row style={{ width: "80%", margin: "auto" }} gutter={16}>
          <Col
            style={progressStyleCol}
            className="gutter-row"
            md={8}
            xs={12}
            span={8}
          >
            <div
              className={
                user?.user?.averageOverall
                  ? "custom-progress"
                  : "custom-progress curcularProgressEmptyFill"
              }
            >
              <Progress
                type="circle"
                percent={
                  user?.user?.averageOverall ? parseInt(user?.user?.averageOverall) : 0
                }
                strokeColor={
                  user?.user?.averageOverall <= user?.user[id] &&
                  user?.user?.averageOverall > 45
                    ? "#FAFF1C"
                    : user?.user?.averageOverall >= user?.user[id] &&
                      user?.user?.averageOverall > 45
                    ? "#67FF0B"
                    : user?.user?.averageOverall < 45
                    ? "red"
                    : "red"
                }
                size={100}
                trailColor="#B5B5B5"
                format={() => (
                  <span className="progress-text">
                    {user?.user?.averageOverall === null
                      ? "N/A"
                      : `${user?.user?.averageOverall}%`}
                  </span>
                )}
              />
            </div>
            <Typography.Text className="progressLabel">
              MY AVERAGE
            </Typography.Text>
          </Col>
          <Col
            style={progressStyleCol}
            className="gutter-row"
            md={8}
            xs={12}
            span={8}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                position: "relative",
              }}
            >
              <img width="70%" src={Trophy} alt="Trophy" />
              <Typography.Text
                className="trophyText"
                style={{
                  position: "absolute",
                  top: "20%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  textAlign: "center",
                }}
              >
                {user?.user[id] >= 0 ? `${user?.user[id]}%` : "N/A"}
                <br />
                {user?.user?.level?.startsWith("primary")
                  ? getGrade(user?.user[id])
                  : getGradeSecondary(user?.user[id])}
              </Typography.Text>
            </div>
            <Typography.Text className="progressLabel">MY GOAL</Typography.Text>
          </Col>
          <Col
            style={progressStyleCol}
            className="gutter-row"
            md={8}
            xs={12}
            span={8}
          >
            <div
              className={
                user?.user?.averageOverallAllWebsite
                  ? "custom-progress"
                  : "custom-progress curcularProgressEmptyFill"
              }
            >
              <Progress
                type="circle"
                percent={
                  user?.user?.averageOverallAllWebsite
                    ? parseInt(user?.user?.averageOverallAllWebsite)
                    : 0
                }
                strokeColor="#18A0FB"
                size={100}
                trailColor="#B5B5B5"
                format={() => (
                  <span className="progress-text">
                    {user?.user?.averageOverallAllWebsite === null
                      ? "N/A"
                      : `${user?.user?.averageOverallAllWebsite}%`}
                  </span>
                )}
              />
            </div>
            <Typography.Text className="progressLabel">
              PEER’S AVERAGE
            </Typography.Text>
          </Col>
        </Row>
        <div style={{ width: "80%", margin: "auto" }}>
          <Divider />
        </div>
        <Row gutter={[16, 16]}>
          <Col
            style={{ ...progressStyleCol, height: "100%" }}
            className="gutter-row"
            md={10}
            xs={12}
            span={8}
          >
            <div className="wrapperBox">
              <Typography.Text className="titleBox">
                AVERAGE MARKS (%) PER MONTH
              </Typography.Text>
              <div style={{ height: "154px" }} className="Chart">
                <ResponsiveContainer width="100%" height="100%">
                  <LineChart
                    margin={{ top: 10, right: 35, left: -27 }}
                    data={user?.user?.last5MonthAverage}
                  >
                    <XAxis
                      dataKey="month"
                      tick={{ fill: "white" }}
                      interval={0}
                      style={{ fontSize: width > 1390 ? "12px" : "6px" }}
                    />
                    <YAxis
                      tick={{
                        fill: "white",
                        fontSize: width > 1390 ? 12 : 6,
                        fontFamily: "Inter",
                      }}
                      domain={[0, 100]}
                      interval={0}
                    />
                    <Tooltip />
                    <CartesianGrid stroke="#7E7E7E" vertical={true} />
                    <ReferenceLine y={0} stroke="white" />
                    <ReferenceLine
                      // y={user?.user[id]}
                      stroke="white"
                      strokeDasharray="9 9"
                      size={2}
                      ifOverflow="extendDomain"
                    />
                    <Line dataKey="value" size={3} stroke="#18A0FB" />
                  </LineChart>
                </ResponsiveContainer>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "6px",
                    position: "absolute",
                    bottom: user?.user[id] ? `${user?.user[id] * 0.79}%` : "0%",
                    width: "100%",
                    right: -10,
                    zIndex: 9999,
                  }}
                >
                  <p style={{ fontSize: "14px", color: "white" }}>Goal</p>
                </div>
              </div>
            </div>
          </Col>
          <Col
            style={{ ...progressStyleCol, height: "100%" }}
            className="gutter-row"
            md={8}
            xs={12}
            span={8}
          >
            <div className="wrapperBox1">
              <Typography.Text className="titleBox">
                MARKS FROM PAST 5 PAPERS
              </Typography.Text>
              <div
                style={{
                  height: "157px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                className="Chart"
              >
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart
                    margin={{ top: 10 }}
                    data={user?.user?.lat5TestsScorePercentage}
                  >
                    <XAxis dataKey="name" tick={{ fill: "white" }} />
                    <YAxis
                      tick={{
                        fill: "white",
                        fontSize: width > 1390 ? 12 : 6,
                        fontFamily: "Inter",
                      }}
                      domain={[0, 100]}
                      interval={0}
                    />
                    <Tooltip
                      content={<CustomTooltip />}
                      cursor={{ fill: "transparent" }}
                    />
                    <CartesianGrid stroke="#7E7E7E" vertical={false} />
                    <ReferenceLine y={0} stroke="white" />
                    <ReferenceLine
                      y={user?.user[id]}
                      stroke="white"
                      strokeDasharray="9 9"
                      size={2}
                    />
                    <Bar
                      dataKey="value"
                      fill="#18A0FB"
                      radius={[10, 10, 0, 0]}
                      barSize={40}
                    />
                  </BarChart>
                </ResponsiveContainer>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "6px",
                    position: "absolute",
                    bottom: user?.user[id] ? `${user?.user[id] * 0.7}%` : "0%",
                    width: "100%",
                    right: 0,
                    zIndex: 9999,
                  }}
                >
                  <p style={{ fontSize: "14px", color: "white" }}>Goal</p>
                </div>
              </div>
            </div>
          </Col>
          <Col
            style={progressStyleCol}
            className="gutter-row"
            md={6}
            xs={24}
            span={8}
          >
            <div className="wrapperBox2">
              <Typography.Text className="titleBox">
                WEEKLY STATISTICS
              </Typography.Text>
              <div className="weeklyStateStack"></div>
              <Typography.Text className="weeklystateText">
                <span style={{ textDecoration: "underline" }}>
                  Papers Completed
                </span>
                <br />
                {user?.user?.papersCompleted >= 0
                  ? user?.user?.papersCompleted
                  : "N/A"}
              </Typography.Text>
              <Typography.Text className="weeklystateText">
                <span style={{ textDecoration: "underline" }}>Hours Spent</span>
                <br />
                {user?.user?.hoursSpend ? user?.user?.hoursSpend : "N/A"}
              </Typography.Text>
              <Typography.Text className="weeklystateText">
                <span style={{ textDecoration: "underline" }}>
                  Average Percentage
                </span>
                <br />
                {user?.user?.average === null
                  ? "N/A"
                  : `${user?.user?.average}%`}
              </Typography.Text>
            </div>
          </Col>
        </Row>
      </div>
      <div className="stateFooter">
        <Row
          style={{ border: "2px solid #F1F1F1", borderRadius: "8px" }}
          gutter={16}
        >
          <Col
            style={{ borderRight: "1px solid #F1F1F1" }}
            className="gutter-row"
            span={12}
            xs={24}
            lg={12}
          >
            <div className="footerInner">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  cursor: "pointer",
                  position: "relative",
                  justifyContent: "center",
                }}
              >
                <Typography.Text className="footerInnerTitle">
                  PRACTICE GOAL
                </Typography.Text>
                <div className="hoverInfoBox">
                  <img className="infoIcon" src={InfoIcon} alt="Info" />
                  <div className="practicalInfo">
                    <Typography.Text className="infoText">
                      The practice goal is a set amount of papers you should
                      complete to increase your chances of reaching your
                      academic goal. This value is determined by the system.
                    </Typography.Text>
                  </div>
                </div>
              </div>
              <div className="space-between">
                <Typography.Text className="progressFooterLabel">
                  Papers Completed:{" "}
                  {user?.user?.completedTest
                    ? user?.user?.completedTest
                    : "N/A"}
                </Typography.Text>
                <Typography.Text className="progressFooterLabel">
                  Goal: {user?.user.goalPapers ? user?.user.goalPapers : "N/A"}
                </Typography.Text>
              </div>
              <div className="progress-wrapper">
                <Progress
                  strokeColor="linear-gradient(180deg, #C6C6C6 0%, #FFF 100%)"
                  size={20}
                  trailColor="#9B9B9B"
                  percent={
                    user?.user.goalPapers
                      ? parseInt(
                          (user?.user.completedTest / user?.user.goalPapers) *
                            100
                        )
                      : 0
                  }
                  showInfo={false}
                />
              </div>
            </div>
          </Col>
          <Col className="gutter-row" span={12} lg={12} xs={24}>
            <div className="footerInner">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  cursor: "pointer",
                  position: "relative",
                  justifyContent: "center",
                }}
              >
                <Typography.Text className="footerInnerTitle">
                  COUNTDOWN
                </Typography.Text>
                <div className="hoverInfoBoxCountDown">
                  <img className="infoIcon" src={InfoIcon} alt="Info" />
                  <div
                    className="countDownInfo"
                    onMouseLeave={() => setInfo(false)}
                  >
                    <Typography.Text className="infoText">
                      The countdown is based on the date you set in ‘Edit
                      Profile’. The start date resets every time you change the
                      date.
                    </Typography.Text>
                  </div>
                </div>
              </div>
              <div className="space-between">
                <Typography.Text className="progressFooterLabel">
                  Days Left:{" "}
                  {user?.user?.countDownTimer
                    ? Math.ceil(
                        (new Date(user?.user?.countDownTimer) - new Date()) /
                          (1000 * 60 * 60 * 24)
                      ) > 0
                      ? Math.ceil(
                          (new Date(user?.user?.countDownTimer) - new Date()) /
                            (1000 * 60 * 60 * 24)
                        )
                      : "Set New CountDown"
                    : "N/A"}
                </Typography.Text>
                <Typography.Text className="progressFooterLabel">
                  {user?.user?.countDownTimer
                    ? new Date(user?.user?.countDownTimer).toLocaleDateString(
                        "en-US",
                        {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        }
                      )
                    : "N/A"}
                </Typography.Text>
              </div>
              <div className="progress-wrapper">
                <Progress
                  strokeColor="linear-gradient(180deg, #C6C6C6 0%, #FFF 100%)"
                  size={20}
                  trailColor="#9B9B9B"
                  percent={percentageDayLeft}
                  showInfo={false}
                />
                <div className="progressInfo">
                  <Typography.Text className="infoText">
                    Days left:{" "}
                    {user?.user?.countDownTimer
                      ? Math.ceil(
                          (new Date(user?.user?.countDownTimer) - new Date()) /
                            (1000 * 60 * 60 * 24)
                        ) > 0
                        ? Math.ceil(
                            (new Date(user?.user?.countDownTimer) -
                              new Date()) /
                              (1000 * 60 * 60 * 24)
                          )
                        : "Set New CountDown"
                      : "N/A"}
                    <br />
                    Countdown set to:{" "}
                    {user?.user?.countDownTimer
                      ? new Date(user?.user?.countDownTimer).toLocaleDateString(
                          "en-US",
                          {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                          }
                        )
                      : "N/A"}
                    <br />
                    Notes on countdown: {user?.user?.notesOnCountDown}
                  </Typography.Text>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SubjectDetails;
